export const DarkTexture = ({ orbs = true }) => (
  <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
    <div className="absolute inset-0 opacity-20" style={{ backgroundImage: 'radial-gradient(#ffffff33 1px, transparent 1px)', backgroundSize: '16px 16px' }} />
    {orbs && (
      <>
        <div className="absolute -top-24 -left-24 w-[32rem] h-[32rem] rounded-full blur-3xl" style={{ background: 'radial-gradient(circle, rgba(217,70,239,0.18) 0%, rgba(5,7,15,0) 70%)' }} />
        <div className="absolute -bottom-32 -right-16 w-[36rem] h-[36rem] rounded-full blur-3xl" style={{ background: 'radial-gradient(circle, rgba(0,240,255,0.14) 0%, rgba(5,7,15,0) 70%)' }} />
      </>
    )}
  </div>
);
